import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

import { PulverizationFromDemandResponse } from './create-pulverization'

export async function getSummaryPulverization(
  culture: string,
  demandId: string,
  options?: AxiosRequestConfig,
) {
  const { data } = await companiesApi.get<PulverizationFromDemandResponse>(
    apiRoutes.getSummaryPulverization(culture, demandId),
    options,
  )

  return data
}
